import GlobalClasses from 'styles/global'
import InputNumber from 'components/Common/InputNumber'
import React from 'react'
import { createUseStyles } from 'react-jss'
import { useTranslation } from 'react-i18next'
import { addToCartGtm } from 'utils/GtmTracking'

const useStyles = createUseStyles((theme) => {
  return {
    ...GlobalClasses,

    btnCart: {
      width: '90px',
      height: '31px',
    },

    accentStyle: {
      background: theme.colors.tintedGrey,
      color: 'white',
      fontWeight: '800',
    },
  }
})

type Props = {
  propName: string
  part: any
  brand: string
  itemsInCart: any
  handleAddToCart: () => void
  handleRemoveFromCart: () => void
  manualCartChange: (number) => void
  accentStyle?: boolean
}

const AddToCartButton: React.ComponentType<Props> = (props: Props) => {
  const { part, brand } = props
  const classes = useStyles()
  const { t } = useTranslation()

  const gtmItem = {
    id: part?.id,
    name: part?.Name,
    brand: brand,
    category: part?.product?.Type?.Name || part?.Category?.Name,
    category2: part?.product?.SubType?.Name,
    price: part?.Price,
    currency: 'CZK',
  }

  // oof
  const value =
    props.itemsInCart[
      props.part?.PartNumber +
        (props.propName === 'devices'
          ? '_' + props.part?.Type?.id + '_' + props.part?.SubType?.id
          : '')
    ]

  return (
    <div>
      {value > 0 ? (
        <InputNumber
          inputChange={(newCount) => {
            props.manualCartChange(newCount)
          }}
          onBlurCallback={(value) => {
            addToCartGtm({ ...gtmItem, quantity: value })
          }}
          value={value}
          handlePlus={props.handleAddToCart}
          handleMinus={props.handleRemoveFromCart}
          gtmItem={gtmItem}
        />
      ) : (
        <button
          className={`${classes.btnSecondary} ${classes.btnSecondary}--small ${
            classes.btnCart
          } ${props.accentStyle ? classes.accentStyle : ''}`}
          onClick={() => {
            props.handleAddToCart()
            addToCartGtm({ ...gtmItem, quantity: 1 })
          }}
        >
          {t('configurator:OPTION_TO_CART')}
        </button>
      )}
    </div>
  )
}

export default AddToCartButton
